import { atom } from 'jotai';

import { type ProgressBar } from '@/services/funnelService/types';

const progressBarAtom = atom<ProgressBar | undefined>(undefined);

export const ProgressBarState = {
  progressBarAtom,
};
